import { render, staticRenderFns } from "./salesInCarTeam.vue?vue&type=template&id=bc5ebd40&"
import script from "./salesInCarTeam.vue?vue&type=script&lang=js&"
export * from "./salesInCarTeam.vue?vue&type=script&lang=js&"
import style0 from "./salesInCarTeam.vue?vue&type=style&index=0&id=bc5ebd40&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports